class GridProductVariants {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.preselectFirstVariants();
  }

  preselectFirstVariants() {
    // Only get grid items within collection grid sections and not in modals
    const collectionGrids = document.querySelectorAll('[data-section-type="collection-grid"]:not(.is-modal)');
    collectionGrids.forEach(grid => {
      // Make sure the grid itself is not within a modal
      if (grid.closest('.is-modal')) return;

      const gridItems = grid.querySelectorAll('.grid__item[data-product-id]');
      gridItems.forEach(item => {
        const productId = item.dataset.productId;
        if (!productId) return;

        const variantsJson = document.getElementById(`ProductVariants-${productId}`);
        if (!variantsJson) return;

        const variants = JSON.parse(variantsJson.textContent);
        const firstAvailableVariant = variants.find(v => v.available) || variants[0];
        if (!firstAvailableVariant) return;

        const form = item.querySelector('.product-single__form');
        if (!form) return;

        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        // Update hidden input with first variant
        input.value = firstAvailableVariant.id;

        // Update add to cart button state
        const addToCartButton = form.querySelector('.add-to-cart');
        if (addToCartButton) {
          if (firstAvailableVariant.available) {
            addToCartButton.classList.remove('btn--secondary');
            addToCartButton.removeAttribute('disabled');
            addToCartButton.querySelector('.add-to-cart__text').textContent = window.theme.strings.addToCart;
          } else {
            addToCartButton.classList.add('btn--secondary');
            addToCartButton.setAttribute('disabled', 'disabled');
            addToCartButton.querySelector('.add-to-cart__text').textContent = window.theme.strings.soldOut;
          }
        }

        // Set active state on first swatch
        const firstSwatch = item.querySelector('.color-swatch');
        if (firstSwatch) {
          firstSwatch.classList.add('is-active');
        }

        // Update price
        this.updatePrice(item, firstAvailableVariant);
      });
    });
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.color-swatch');
      if (!swatch) return;

      // Only handle swatches within collection grid sections and not in modals
      const collectionGrid = swatch.closest('[data-section-type="collection-grid"]');
      const modal = swatch.closest('.is-modal');
      if (!collectionGrid || modal) return;

      const productContainer = swatch.closest('.grid__item');
      if (!productContainer) return;

      event.preventDefault();
      
      const productId = productContainer.dataset.productId;
      if (!productId) return;

      // Get variant ID from the swatch
      const variantId = swatch.dataset.variantId;
      if (!variantId) return;

      // Update active state
      const allSwatches = productContainer.querySelectorAll('.color-swatch');
      allSwatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Update hidden input with selected variant
      const form = productContainer.querySelector('.product-single__form');
      if (!form) return;

      const input = form.querySelector('input[name="id"]');
      if (!input) return;

      input.value = variantId;

      // Get variant data and update price
      const variantsJson = document.getElementById(`ProductVariants-${productId}`);
      if (!variantsJson) return;

      try {
        const variants = JSON.parse(variantsJson.textContent);
        const selectedVariant = variants.find(v => v.id.toString() === variantId);
        
        if (selectedVariant) {
          // Update price
          this.updatePrice(productContainer, selectedVariant);

          // Update add to cart button state
          const addToCartButton = form.querySelector('.add-to-cart');
          if (addToCartButton) {
            const buttonText = addToCartButton.querySelector('.add-to-cart__text');
            if (selectedVariant.available) {
              addToCartButton.classList.remove('btn--secondary');
              addToCartButton.removeAttribute('disabled');
              if (buttonText) {
                buttonText.textContent = window.theme.strings.addToCart;
              }
            } else {
              addToCartButton.classList.add('btn--secondary');
              addToCartButton.setAttribute('disabled', 'disabled');
              if (buttonText) {
                buttonText.textContent = window.theme.strings.soldOut;
              }
            }
          }

          // Update product image if variant has an image
          const image = productContainer.querySelector('.grid__image-ratio img, .image-wrap img');
          if (image && selectedVariant.featured_media) {
            const imgUrl = selectedVariant.featured_media.preview_image.src;
            const baseUrl = imgUrl.replace(/(_\d+x)?\.jpg|\.png/, '');
            
            image.src = imgUrl;
            image.setAttribute('data-src', `${baseUrl}_{width}x.${imgUrl.split('.').pop()}`);
            
            // If image has srcset, update it as well
            if (image.dataset.widths) {
              const widths = JSON.parse(image.dataset.widths);
              const srcset = widths.map(width => {
                return `${baseUrl}_${width}x.${imgUrl.split('.').pop()} ${width}w`;
              }).join(', ');
              image.srcset = srcset;
            }
          }
        }
      } catch (e) {
        console.error('Error updating variant:', e);
      }
    });
  }

  updatePrice(container, variant) {
    const priceContainer = container.querySelector('.grid-product__price');
    if (!priceContainer) return;

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;
    const onSale = compareAtPrice && compareAtPrice > price;

    // Get or create current price element
    let currentPriceElement = priceContainer.querySelector('.grid-product__price--current-price');
    if (!currentPriceElement) {
      currentPriceElement = document.createElement('span');
      currentPriceElement.classList.add('grid-product__price--current-price');
      priceContainer.appendChild(currentPriceElement);
    }

    currentPriceElement.innerHTML = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
    
    // Ensure only current price is shown in varies element
    let variesPriceElement = priceContainer.querySelector('.grid-product__price--varies');
    if (variesPriceElement) {
      variesPriceElement.innerHTML = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
      // Hide current price element if varies element is present
      currentPriceElement.style.display = 'none';
    } else {
      currentPriceElement.style.display = '';
    }

    // Handle compare at price
    let originalPriceElement = priceContainer.querySelector('.grid-product__price--original');
    if (onSale) {
      if (!originalPriceElement) {
        originalPriceElement = document.createElement('span');
        originalPriceElement.classList.add('grid-product__price--original');
        priceContainer.insertBefore(originalPriceElement, priceContainer.firstChild);
      }
      originalPriceElement.innerHTML = theme.Currency.formatMoney(compareAtPrice, theme.settings.moneyFormat);
      originalPriceElement.style.display = '';

      // Update savings
      let savingsElement = priceContainer.querySelector('.grid-product__price--savings');
      if (!savingsElement) {
        savingsElement = document.createElement('span');
        savingsElement.classList.add('grid-product__price--savings');
        priceContainer.appendChild(savingsElement);
      }
      const savedAmount = ((compareAtPrice - price) * 100.0 / compareAtPrice).toFixed(0);
      savingsElement.innerHTML = `Save ${savedAmount}%`;
      savingsElement.style.display = '';
    } else {
      if (originalPriceElement) {
        originalPriceElement.style.display = 'none';
      }
      const savingsElement = priceContainer.querySelector('.grid-product__price--savings');
      if (savingsElement) {
        savingsElement.style.display = 'none';
      }
    }

    // Handle unit price if it exists
    let unitPriceElement = priceContainer.querySelector('.product__unit-price');
    if (variant.unit_price_measurement) {
      if (!unitPriceElement) {
        unitPriceElement = document.createElement('div');
        unitPriceElement.classList.add('product__unit-price');
        priceContainer.appendChild(unitPriceElement);
      }

      const unitPriceBaseUnit = variant.unit_price_measurement.reference_value !== 1 
        ? variant.unit_price_measurement.reference_value 
        : '';
      
      unitPriceElement.innerHTML = `${theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat)}/${unitPriceBaseUnit}${variant.unit_price_measurement.reference_unit}`;
      unitPriceElement.style.display = '';
    } else if (unitPriceElement) {
      unitPriceElement.style.display = 'none';
    }
  }
}

// Initialize on page load
if (typeof window.theme === 'undefined') {
  window.theme = {};
}

window.theme.strings = window.theme.strings || {};
window.theme.strings.addToCart = window.theme.strings.addToCart || "Add to cart";
window.theme.strings.soldOut = window.theme.strings.soldOut || "Sold out";
window.theme.strings.saveHtml = window.theme.strings.saveHtml || "Save [saved_amount]%";

document.addEventListener('DOMContentLoaded', () => {
  new GridProductVariants();
});
